/**
 * CurrentTeamField — the Current Team autocomplete field for the
 * manually-add-player modal.
 * @module components/organisms/ManuallyAddPlayerModal/CurrentTeamField
 */

export { default } from "./CurrentTeamFieldContainer";
export { renderCurrentTeamField } from "./CurrentTeamFieldContainer";
export type { CurrentTeamFieldContainerProps } from "./CurrentTeamFieldContainer";
export type { CurrentTeamFieldViewProps } from "./CurrentTeamFieldView";
